import React, {Component} from 'react'
import TagSuggestions from './TagSuggestions'
import Tag from './Tag'
class AddTagsForm extends Component {

    state = {
        recentlyCreatedTagName: "",
        newTagName: '',
        newTagNames: [],
        allTags: [],
        selectedTagIds: [],
        searchInput: "",
    };

    assignTags = () => {
        let payload = {
            wip_id: this.props.wi._id,
            newTagNames: this.state.newTagNames,
            selectedTagIds: this.state.selectedTagIds
        }
        this.props.assignTags(payload)
    } 

    checkKey = (e) => {
        if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
            if(this.state.newTagName) {
                this.addTag(e, this.state.newTagName)
            }
        }
    }

    componentDidMount = () => {
            var newTagInput = document.getElementById("tag-name");
            newTagInput.addEventListener("keydown", this.checkKey);
    }

    componentWillUnmount = () => {
        var newTagInput = document.getElementById("tag-name");
        newTagInput.removeEventListener("keydown", this.checkKey)
    }

    addTag = (e, tagName) => {
        e.stopPropagation()
        let tagId = undefined
        let tagExist = false
        Object.values(this.props.tags).forEach(tag => {
            if (tag.name === tagName) {
                tagExist = true
                tagId = tag._id
            }
        })

        let newTagNames = this.state.newTagNames
        let allTags = this.state.allTags
        let selectedTagIds = this.state.selectedTagIds
        if (tagExist) {
            allTags.push(tagName)
            selectedTagIds.push(tagId)
            this.setState(prevState => ({
                newTagNames,
                selectedTagIds,
                newTagName: ""
            }));
        } else {
            allTags.push(tagName)
            newTagNames.push(tagName)
            this.setState(prevState => ({
                newTagNames,
                allTags,
                newTagName: ""
            }));
        }
    }

    removePendingTagName = (e, pendingRemovalName) => {
        e.stopPropagation()
        let allTags = this.state.allTags
        let newTagNames = this.state.newTagNames
        let selectedTagIds = this.state.selectedTagIds
        let tagId 
        Object.values(this.props.tags).forEach(tag => {
            if (tag.name.toLowerCase() === pendingRemovalName.toLowerCase()) {
                tagId = tag._id
            }
        })

        allTags = allTags.filter(tagName => tagName !== pendingRemovalName)
        newTagNames = newTagNames.filter(tagName => tagName !== pendingRemovalName)
        if(tagId) {
            selectedTagIds = selectedTagIds.filter(checkId => checkId !== tagId)
        }

        this.setState({
            newTagNames,
            allTags,
            selectedTagIds
        })
    }



    selectTag = (e, tag) => {
        e.stopPropagation()
        let allTags = this.state.allTags
        let selectedTagIds = this.state.selectedTagIds
        selectedTagIds.push(tag._id)
        allTags.push(tag.name)
        this.setState(prevState => ({
            selectedTagIds,
            allTags
        }));
    }



    update(field) {
        return event => this.setState({
            [field]: event.currentTarget.value,
        });
    }

    render() {
    //     const currentTags = this.state.allTags.map(tag => <li className="flex clickable tag-button" key={`all-tags form ${tag._id}`}
    //     onClick = {(e) => this.removePendingTagName(e, tag)
    // }
    //     >
    // {`#${tag}`}<p style={{ color: "red", marginLeft: ".3125em" }}>x</p></li >)
        const currentTags = this.state.allTags.map(tag => 
            <Tag isAttached={true} 
                label={tag} 
                key={`all-tags form ${tag._id}`} 
                handleDelete={(e) => this.removePendingTagName(e, tag)} 
            />)
       return <div>
            <ul id="selected-tag-names-container" className="flex wrap">
                <label>Current Tags:</label>
                {currentTags}
            </ul>

            <div id="new-tag-name-container" className="flex wrap">
                <label>Add A New Tag</label>
                <input id="tag-name"
                    type="text"
                    value={this.state.newTagName}
                    onChange={this.update('newTagName')}
                    placeholder=""
                />
            </div>

            <div className='input-box' style={{ width: "95%" }}>
                <div id="search-tag-name-container">
                    <label>Search Recent/Popular Tags</label>
                    <input id="search-tag-name"
                        type="text"
                        value={this.state.searchInput}
                        onChange={this.update('searchInput')}
                        placeholder=""
                    />
                </div>
            </div>
           <TagSuggestions
                visible={true}
                tags={this.props.tags}
                query={this.state.searchInput}
                currentTags={this.state.allTags}
                selectTag={this.selectTag} />
            <div className="flex-centered">
                <div className="button clickable" onClick={this.assignTags}>
                    {this.state.selectedTagIds.length > 0 || this.state.newTagNames.length > 0 ? <p>Assign Tags To Work Instruction </p> : 
                       <p>Continue Without Tags</p> }
                </div>
            </div>
        </div>
    }
}
export default AddTagsForm